export default __webpack_public_path__ + "static/media/about-page-img.f31d0615.png";